var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1788000899436,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 82486,
    id: "mx_n_1788000899437",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 146.870565C0 65.503248 65.503248 0 146.870565 0h730.25887C957.985007 0 1023.488256 65.503248 1023.488256 146.870565v730.25887c0 80.855572-65.503248 146.358821-146.358821 146.870565H146.870565C66.014993 1023.488256 0 957.985007 0 877.129435V146.870565z m219.538231 72.667666l32.23988 32.23988 32.751624 32.751624 32.23988 32.23988v357.197401l-97.231384 97.231385v32.751624h519.932034l64.991504-227.214393-32.23988 32.23988-32.751624 32.751624-32.23988 32.23988H446.752624V316.769615l32.751624-32.23988 32.751624-32.751624 32.23988-32.23988H219.538231z",
    "p-id": 82487
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLol);
export default __webpack_public_path__ + "static/media/lol.bce6684d7d2bf4f444ec0c11f9fb6835.svg";
export { ForwardRef as ReactComponent };